'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

/* Wraps glamor's stylesheet and exports a singleton for the rest
*  of the app to use. */

var _sheet = require('../vendor/glamor/sheet');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StyleSheet = function () {
  function StyleSheet() {
    _classCallCheck(this, StyleSheet);

    this.styleSheet = new _sheet.StyleSheet({ speedy: false, maxLength: 40 });
  }

  _createClass(StyleSheet, [{
    key: 'inject',
    value: function inject() {
      return this.styleSheet.inject();
    }
  }, {
    key: 'insert',
    value: function insert(css) {
      return this.styleSheet.insert(css);
    }
  }, {
    key: 'reset',
    value: function reset() {
      if (this.styleSheet.sheet) this.styleSheet.flush();
    }
  }, {
    key: 'getCSS',
    value: function getCSS() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$min = _ref.min,
          min = _ref$min === undefined ? true : _ref$min;

      return this.styleSheet.sheet ? this.styleSheet.rules().map(function (rule) {
        return rule.cssText;
      }).join(min ? '' : '\n') : '';
    }
  }, {
    key: 'injected',
    get: function get() {
      return this.styleSheet.injected;
    }
  }]);

  return StyleSheet;
}();

exports.default = new StyleSheet();
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /Users/glen/src/projects/css-components/styled-components/lib/models/StyleSheet.js
// module id = 80
// module chunks = 0